// extracted by mini-css-extract-plugin
module.exports = {"root":"BookPageContainer_root__pGU0f","inner":"BookPageContainer_inner__ULJAy","label":"BookPageContainer_label__7ynL3","list":"BookPageContainer_list__WXMGO"};